module.exports = __webpack_public_path__ + "static/media/rectangle-pg.01f87439.png";